"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SearchTags.css");
var UIProps_1 = require("../UIProps");
var Button_1 = require("../button/Button");
var Icon_1 = require("../icon/Icon");
var SearchTagsComp = function (props) {
    return props.labels.length > 0 ? (React.createElement("div", __assign({ role: 'list', "aria-label": 'Search tags' }, UIProps_1.setUIProps(props), { className: classnames_1.default('SearchTags', props.className) }), props.labels.map(function (label, index) { return (React.createElement("div", { role: 'listitem', className: "SearchTag", key: index },
        React.createElement("span", null, label),
        React.createElement(Button_1.Button, { className: 'SearchTag_closeButton', "aria-label": 'Close search tag', onClick: function (e) {
                props.onClose(label, e);
            } },
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.close })))); }))) : (React.createElement(React.Fragment, null));
};
exports.SearchTags = React.memo(SearchTagsComp);
